export default "__VITE_ASSET__4aea5d45__"